import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { filter, pipe, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { inject } from '@angular/core';
import { TelInputService } from './infra/tel-input.service';
import { ICountryCodesPhoneNumber } from './entities/tel-input.model';
import { LanguageStore } from '@settings/language/data-access';

type TelInputStore = {
  phoneNumberCountryCode: ICountryCodesPhoneNumber[];
  phoneNumberCountryCodeByLanguage: Record<string, ICountryCodesPhoneNumber[] | 'loading'>;
}

export const telInputStore: TelInputStore = {
  phoneNumberCountryCode: null,
  phoneNumberCountryCodeByLanguage: {},
}

export const TelInputStore = signalStore(
  {providedIn: 'root'},
  withState(telInputStore),
  withMethods((
    store,
    telInputService = inject(TelInputService),
    languageStore = inject(LanguageStore)) => ({
      loadCountryCodesPhoneNumber: rxMethod<void>(pipe(
        filter(() => {
          const lang = languageStore.language().split('-')[0];
          const phoneNumberCountryCode = store.phoneNumberCountryCodeByLanguage()[lang];

          if (phoneNumberCountryCode === 'loading') return false;

          if (phoneNumberCountryCode && phoneNumberCountryCode.length > 0) {
            patchState(store, { phoneNumberCountryCode });
            return false;
          }
          return true;
        }),
        switchMap(() => {
          const lang = languageStore.language().split('-')[0];
          patchState(store, { phoneNumberCountryCodeByLanguage: { ...store.phoneNumberCountryCodeByLanguage(), [lang]: 'loading' } });
          return telInputService
          .getCountryCodesPhoneNumber(lang).pipe(
          tapResponse({
            next: (phoneNumberCountryCode) =>
              patchState(store, { phoneNumberCountryCode, phoneNumberCountryCodeByLanguage: { ...store.phoneNumberCountryCodeByLanguage(), [lang]: phoneNumberCountryCode }}),
            error: (error) => {
              console.error(error);
              patchState(store, { phoneNumberCountryCodeByLanguage: { ...store.phoneNumberCountryCodeByLanguage(), [lang]: null } });
            }
          })
          )}
      )
      ))
    })
  )
)
